module.exports = "<aside class=\"aside-menu\">\r\n  \r\n</aside>\r\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/app-aside/app-aside.component.html
// module id = ../../../../../src/app/components/app-aside/app-aside.component.html
// module chunks = main